import { useQuery } from '@apollo/client';
import { useDispatch } from 'react-redux';
import { actionSetMachineSchedule } from 'lib/actions';
import { GET_MACHINE_SCHEDULE } from 'lib/api/queries';
import { useEffect } from 'react';

export const useRequestMachineSchedule = ({ skip = false, variables = {} }) => {
  const dispatch = useDispatch();

  const requestMachineSchedule = useQuery(GET_MACHINE_SCHEDULE, {
    variables,
    fetchPolicy: 'no-cache',
    notifyOnNetworkStatusChange: true,
    skip,
    onCompleted: ({ machineSchedule }) => {
      if (machineSchedule?.schedule) {
        const machineValues = Object.values(machineSchedule.schedule)[0];
        const formatted = machineValues.upcoming.map((orderOp) => {
          return {
            ...orderOp,
            closedDate: null,
            finishQuantity: orderOp.quantityRequired,
            scheduledStartDate: orderOp.scheduledStartAt,
            sequenceNumber: orderOp.sequence,
            workOrder: {
              ...(orderOp.workOrder || {}),
              lot: orderOp.lot,
              partNumber: orderOp.partNumber,
              split: orderOp.split,
              sub: orderOp.sub ?? orderOp.workOrder?.sub,
              workOrderId: orderOp.workOrderId,
              dueDate: orderOp.workOrderDueDate,
            },
            workOrderId: orderOp.workOrderId,
            workOrderOperationRef: orderOp.workOrderOperationRef,
          };
        });
        dispatch(actionSetMachineSchedule(formatted));
      }
    },
  });

  useEffect(() => {
    if (skip) {
      dispatch(actionSetMachineSchedule(null));
    }
  }, [skip, dispatch]);

  return requestMachineSchedule;
};
